module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-spinner"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Spinner")]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "snake"
    }
  }, [_c('mt-spinner', {
    attrs: {
      "color": "#26a2ff",
      "type": "snake"
    }
  })], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "double-bounce"
    }
  }, [_c('mt-spinner', {
    attrs: {
      "color": "#26a2ff",
      "type": "double-bounce"
    }
  })], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "triple-bounce"
    }
  }, [_c('mt-spinner', {
    attrs: {
      "color": "#26a2ff",
      "type": "triple-bounce"
    }
  })], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "fading-circle"
    }
  }, [_c('mt-spinner', {
    attrs: {
      "color": "#26a2ff",
      "type": "fading-circle"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0da4499b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/spinner.vue
// module id = 265
// module chunks = 0